const ADDRESS = 1;
const ROOM = 2;
const CUPBOARD = 3;
const SHELF = 4;
const BOX = 5;
const PLACE = 6;

const LOCATION_TYPE_LIST = {
  ADDRESS,
  ROOM,
  CUPBOARD,
  SHELF,
  BOX,
  PLACE,
};

export const LOCATION_TYPE_LABELS = [
  {
    id: ADDRESS,
    name: 'адрес',
  },
  {
    id: ROOM,
    name: 'комната',
  },
  {
    id: CUPBOARD,
    name: 'шкаф',
  },
  {
    id: SHELF,
    name: 'полка',
  },
  {
    id: BOX,
    name: 'коробка',
  },
  {
    id: PLACE,
    name: 'место',
  },
];

export const getLocationTypeLabel = (type) => {
  const [first] = LOCATION_TYPE_LABELS.filter(((item) => item.id === type));
  return first.name;
};

export default LOCATION_TYPE_LIST;
